/**
 * @desc Route path names used inside `router.config.jsx`.
 * @example
 * import * as ROUTE_PATHS from 'constants/route-paths';
 * console.log( ROUTE_PATHS.HOME );
 */

// main routes
export const HOME = '/';
export const DASHBOARD = '/account-management';
export const REPORTS = '/reports';
export const ADMINISTRATION = '/administration';
export const ACCESS_MANAGEMENT = '/access-management';

// helper routes
export const NOT_FOUND = '/not-found';
export const UNAUTHENTICATED = '/unauthenticated';
export const REDIRECT = '';
export const SSO_LOGOUT = '/sso-logout';


// saml SSO paths
export const SAML_ERROR = '/saml/error';
export const SAML_LOGIN = '/saml/login';

/*-----------*/

// dashboard sub-routes
export const DASHBOARD_SUB_ROUTES = {
    CALL_MANAGEMENT_LISTS: DASHBOARD, // default landing view
    CALL_AUTHORIZATION_FLOW: `${ DASHBOARD }/call-authorization-flow`,
    CALL_DETAIL: `${ DASHBOARD }/call-detail`,
    ACTION_DETAIL: `${ DASHBOARD }/action-detail`,
    MEMBER_MANAGEMENT: `${ DASHBOARD }/member-management`,
    ORDER_DETAIL: `${ DASHBOARD }/order`,
    EDIT_ORDER: `${ DASHBOARD }/edit-order`,
    RE_ORDER: `${ DASHBOARD }/re-order`,
    NEW_ORDER: `${ DASHBOARD }/new-order`,
    CLAIM_DETAIL: `${ DASHBOARD }/claim`,
    PRESCRIPTION_DETAIL: `${ DASHBOARD }/prescription`,
    DRUG_SEARCH: `${ DASHBOARD }/drug-search`,
    ENROLL_TO_EPOST: `${ DASHBOARD }/enroll-to-epost`,
    REACTIVATE_EPOST: `${ DASHBOARD }/reactivate-epost`,
    PAY_BALANCE: `${ DASHBOARD }/pay-balance`,
    TO_DO_DETAIL: `${ DASHBOARD }/todo-detail`,
    ENABLE_AUTO_REFILL: `${ DASHBOARD }/enable-auto-refill`,
    MEMBER_ALERTS: `${ DASHBOARD }/member-alerts`,
    PRIOR_AUTH_DETAILS: `${ DASHBOARD }/prior-auth`
};
